export default "__VITE_ASSET__BUfC3Cvz__"